import { render, staticRenderFns } from "./OmnichannelStrategyPage.vue?vue&type=template&id=30edba2a&scoped=true"
import script from "./OmnichannelStrategyPage.vue?vue&type=script&lang=ts"
export * from "./OmnichannelStrategyPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30edba2a",
  null
  
)

export default component.exports